import { render, staticRenderFns } from "./DenunciationCreate.vue?vue&type=template&id=4fdbcb78&scoped=true&"
import script from "./DenunciationCreate.vue?vue&type=script&lang=js&"
export * from "./DenunciationCreate.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationCreate.vue?vue&type=style&index=0&id=4fdbcb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbcb78",
  null
  
)

export default component.exports